"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeToWarehouseItems = exports.deleteWarehouseItemRealTime = exports.editWarehouseItemRealTime = exports.addWarehouseItemRealTime = exports.confirmSendTransfer = exports.importNewItem = exports.editWarehouseItem = exports.deleteWarehouseItem = exports.addWarehouseItem = exports.fetchWarehouseItemsByWarehouseIdStockNumber = exports.fetchWarehouseItemMovementByStockNumber = exports.fetchWarehouseItemsReport = exports.fetchWarehouseItemsByWarehouseId = exports.fetchWarehouseItemsInBatches = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var supabaseClient_1 = require("../../supabaseClient"); // Adjust the import path as needed
var moment_1 = __importDefault(require("moment"));
var initialState = {
    data: [],
    warehouseItem: {},
    warehouseItemMovementByStockNumber: [],
    warehouseReport: [],
    status: "idle",
    reportStatus: "idle",
    error: null,
    globalWarehouseItemsData: {},
    loaded: false,
};
// Fetch all warehouse items in batches
exports.fetchWarehouseItemsInBatches = (0, toolkit_1.createAsyncThunk)("warehouseItems/fetchWarehouseItemsInBatches", function (_, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, data, error;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase.from("warehouseItems").select("*")];
                case 1:
                    _b = _c.sent(), data = _b.data, error = _b.error;
                    if (error) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
// Fetch all warehouse items in batches
exports.fetchWarehouseItemsByWarehouseId = (0, toolkit_1.createAsyncThunk)("warehouseItems/fetchWarehouseItemsByWarehouseId", function (warehouseId, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, data, error;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase
                        .from("warehouseItems")
                        .select("*")
                        .eq("warehouseId", warehouseId)];
                case 1:
                    _b = _c.sent(), data = _b.data, error = _b.error;
                    if (error) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
// Fetch all warehouse items in batches
exports.fetchWarehouseItemsReport = (0, toolkit_1.createAsyncThunk)("warehouseItems/fetchWarehouseItemsReport", function (_a, _b) {
    var warehouseId = _a.warehouseId, startDate = _a.startDate, endDate = _a.endDate;
    var rejectWithValue = _b.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _c, data, error;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase.rpc("fetch_warehouse_items_with_consumed_and_date_range", {
                        warehouse_id: warehouseId,
                        start_date: (0, moment_1.default)(startDate).toISOString(),
                        end_date: (0, moment_1.default)(endDate).toISOString(),
                    })];
                case 1:
                    _c = _d.sent(), data = _c.data, error = _c.error;
                    if (error) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
exports.fetchWarehouseItemMovementByStockNumber = (0, toolkit_1.createAsyncThunk)("warehouseItems/fetchWarehouseItemMovementByStockNumber", function (stockNumber, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, data, error;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase.rpc("fetch_operations_by_stock_number", {
                        stock_number: stockNumber,
                    })];
                case 1:
                    _b = _c.sent(), data = _b.data, error = _b.error;
                    if (error) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
// Fetch all warehouse items in batches
exports.fetchWarehouseItemsByWarehouseIdStockNumber = (0, toolkit_1.createAsyncThunk)("warehouseItems/fetchWarehouseItemsByWarehouseIdStockNumber", function (_a, _b) {
    var warehouseId = _a.warehouseId, stockNumber = _a.stockNumber, productId = _a.productId, projectId = _a.projectId;
    var rejectWithValue = _b.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _c, data, error;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase
                        .from("warehouseItems")
                        .select("*")
                        .eq("warehouseId", warehouseId)
                        .eq("stockNumber", stockNumber)
                        .eq("productId", productId)
                        .eq("projectId", projectId)
                        .single()];
                case 1:
                    _c = _d.sent(), data = _c.data, error = _c.error;
                    if (error) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
// Add a new warehouse item
exports.addWarehouseItem = (0, toolkit_1.createAsyncThunk)("warehouseItems/addWarehouseItem", function (newItem, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, insertData, insertError;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("warehouseItems")
                    .insert(newItem)
                    .select()
                    .single()];
            case 1:
                _a = _b.sent(), insertData = _a.data, insertError = _a.error;
                if (insertError) {
                    return [2 /*return*/, thunkApi.rejectWithValue(insertError.message)];
                }
                return [2 /*return*/, insertData];
        }
    });
}); });
// Delete a warehouse item
exports.deleteWarehouseItem = (0, toolkit_1.createAsyncThunk)("warehouseItems/deleteWarehouseItem", function (id, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("warehouseItems")
                    .delete()
                    .eq("id", id)];
            case 1:
                error = (_a.sent()).error;
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/, id];
        }
    });
}); });
// Edit a warehouse item
exports.editWarehouseItem = (0, toolkit_1.createAsyncThunk)("warehouseItems/editWarehouseItem", function (updatedItem, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, updateData, updateError;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("warehouseItems")
                    .update(updatedItem)
                    .eq("id", updatedItem.id)
                    .select()
                    .single()];
            case 1:
                _a = _b.sent(), updateData = _a.data, updateError = _a.error;
                if (updateError) {
                    return [2 /*return*/, thunkApi.rejectWithValue(updateError.message)];
                }
                return [2 /*return*/, updateData];
        }
    });
}); });
// import new item to warehouse rpc
exports.importNewItem = (0, toolkit_1.createAsyncThunk)("warehouseItems/importNewItem", function (_a, thunkApi) {
    var item = _a.item, product = _a.product, sameProducts = _a.sameProducts, serialNumbers = _a.serialNumbers, assetsNumbers = _a.assetsNumbers, quantity = _a.quantity, userId = _a.userId, warehouseId = _a.warehouseId, sameProductQuantity = _a.sameProductQuantity;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, data, error;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase.rpc("import_warehouse_item", {
                        p_item: item,
                        p_product: product,
                        p_same_products: sameProducts,
                        p_serial_numbers: serialNumbers !== null && serialNumbers !== void 0 ? serialNumbers : [],
                        p_assets_numbers: assetsNumbers !== null && assetsNumbers !== void 0 ? assetsNumbers : [],
                        p_quantity: quantity,
                        p_user_id: userId,
                        p_warehouse_id: warehouseId,
                        p_same_product_quantity: sameProductQuantity,
                    })];
                case 1:
                    _b = _c.sent(), data = _b.data, error = _b.error;
                    if (error) {
                        return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, "done"];
            }
        });
    });
});
exports.confirmSendTransfer = (0, toolkit_1.createAsyncThunk)("warehouseItems/confirmSendTransfer", function (_a, thunkApi) {
    var warehouse_transfer_operation_id = _a.warehouse_transfer_operation_id, user_id = _a.user_id;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, updateData, updateError;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase.rpc("confirm_send_transfer", {
                        warehouse_transfer_operation_id: warehouse_transfer_operation_id,
                        user_id: user_id,
                    })];
                case 1:
                    _b = _c.sent(), updateData = _b.data, updateError = _b.error;
                    if (updateError) {
                        return [2 /*return*/, thunkApi.rejectWithValue(updateError.message)];
                    }
                    return [2 /*return*/, updateData];
            }
        });
    });
});
// Real-time actions
var addWarehouseItemRealTime = function (newItem) { return ({
    type: "warehouseItems/addWarehouseItemRealTime",
    payload: newItem,
}); };
exports.addWarehouseItemRealTime = addWarehouseItemRealTime;
var editWarehouseItemRealTime = function (updatedItem) { return ({
    type: "warehouseItems/editWarehouseItemRealTime",
    payload: updatedItem,
}); };
exports.editWarehouseItemRealTime = editWarehouseItemRealTime;
var deleteWarehouseItemRealTime = function (id) { return ({
    type: "warehouseItems/deleteWarehouseItemRealTime",
    payload: id,
}); };
exports.deleteWarehouseItemRealTime = deleteWarehouseItemRealTime;
// Slice definition
var warehouseItemsSlice = (0, toolkit_1.createSlice)({
    name: "warehouseItems",
    initialState: initialState,
    reducers: {
        addWarehouseItemRealTime: function (state, action) {
            var exists = state.data.some(function (item) { return item.id === action.payload.id; });
            if (!exists) {
                state.data.push(action.payload);
            }
            state.error = null;
        },
        editWarehouseItemRealTime: function (state, action) {
            var index = state.data.findIndex(function (item) { return item.id === action.payload.id; });
            if (index !== -1) {
                var isDifferent = JSON.stringify(state.data[index]) !== JSON.stringify(action.payload);
                if (isDifferent) {
                    state.data[index] = action.payload;
                }
            }
            state.error = null;
        },
        deleteWarehouseItemRealTime: function (state, action) {
            var exists = state.data.some(function (item) { return item.id === action.payload; });
            if (exists) {
                state.data = state.data.filter(function (item) { return item.id !== action.payload; });
            }
            state.error = null;
        },
    },
    extraReducers: function (builder) {
        builder
            // fetch all warehouse items
            .addCase(exports.fetchWarehouseItemsInBatches.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchWarehouseItemsInBatches.fulfilled, function (state, action) {
            state.loaded = true;
            action.payload.forEach(function (item) {
                var _a;
                state.globalWarehouseItemsData[(_a = item.id) !== null && _a !== void 0 ? _a : ""] = item;
            });
        })
            .addCase(exports.fetchWarehouseItemsInBatches.rejected, function (state, action) {
            state.status = "failed";
            state.error =
                action.payload || "Failed to fetch warehouse items.";
        })
            // fetch all warehouse items by id
            .addCase(exports.fetchWarehouseItemsByWarehouseId.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchWarehouseItemsByWarehouseId.fulfilled, function (state, action) {
            state.loaded = true;
            state.data = action.payload;
            state.status = "succeeded";
        })
            .addCase(exports.fetchWarehouseItemsByWarehouseId.rejected, function (state, action) {
            state.status = "failed";
            state.error =
                action.payload || "Failed to fetch warehouse items.";
        })
            // fetch all warehouse items by id
            .addCase(exports.fetchWarehouseItemsByWarehouseIdStockNumber.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchWarehouseItemsByWarehouseIdStockNumber.fulfilled, function (state, action) {
            state.loaded = true;
            state.warehouseItem = action.payload;
            state.status = "succeeded";
        })
            .addCase(exports.fetchWarehouseItemsByWarehouseIdStockNumber.rejected, function (state, action) {
            state.status = "failed";
            state.error =
                action.payload || "Failed to fetch warehouse items.";
        })
            // fetch all warehouse items by id
            .addCase(exports.fetchWarehouseItemsReport.pending, function (state) {
            state.reportStatus = "loading";
        })
            .addCase(exports.fetchWarehouseItemsReport.fulfilled, function (state, action) {
            // state.loaded = true;
            state.warehouseReport = action.payload;
            state.reportStatus = "succeeded";
        })
            .addCase(exports.fetchWarehouseItemsReport.rejected, function (state, action) {
            state.reportStatus = "failed";
            state.error =
                action.payload || "Failed to fetch warehouse items.";
        })
            // fetch all warehouse items by id
            .addCase(exports.fetchWarehouseItemMovementByStockNumber.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchWarehouseItemMovementByStockNumber.fulfilled, function (state, action) {
            state.loaded = true;
            state.warehouseItemMovementByStockNumber = action.payload;
            state.status = "succeeded";
        })
            .addCase(exports.fetchWarehouseItemMovementByStockNumber.rejected, function (state, action) {
            state.status = "failed";
            state.error =
                action.payload || "Failed to fetch warehouse items.";
        })
            // Handle addWarehouseItem
            .addCase(exports.addWarehouseItem.fulfilled, function (state, action) {
            state.error = null;
        })
            .addCase(exports.addWarehouseItem.rejected, function (state, action) {
            state.error = action.payload || "Failed to add warehouse item.";
        })
            // Handle importNewItem
            .addCase(exports.importNewItem.fulfilled, function (state, action) {
            state.error = null;
        })
            .addCase(exports.importNewItem.rejected, function (state, action) {
            state.error = action.payload || "Failed to import warehouse item.";
        })
            // Handle deleteWarehouseItem
            .addCase(exports.deleteWarehouseItem.fulfilled, function (state, action) {
            state.data = state.data.filter(function (item) { return item.id !== action.payload; });
            state.error = null;
        })
            .addCase(exports.deleteWarehouseItem.rejected, function (state, action) {
            state.error = action.payload || "Failed to delete warehouse item.";
        })
            // Handle editWarehouseItem
            .addCase(exports.editWarehouseItem.fulfilled, function (state, action) {
            var index = state.data.findIndex(function (item) { return item.id === action.payload.id; });
            if (index !== -1) {
                state.data[index] = action.payload;
            }
            state.error = null;
        })
            .addCase(exports.editWarehouseItem.rejected, function (state, action) {
            state.error = action.payload || "Failed to edit warehouse item.";
        })
            // Handle confirmSendTransfer
            .addCase(exports.confirmSendTransfer.fulfilled, function (state, action) {
            console.log(state.data, "+++++++++++++++++++++");
            // const index = state.data.findIndex(
            //   (item) => item.id === action.payload.id
            // );
            // if (index !== -1) {
            //   state.data[index] = action.payload;
            // }
            state.error = null;
        })
            .addCase(exports.confirmSendTransfer.rejected, function (state, action) {
            state.error = action.payload || "Failed to edit warehouse item.";
        });
    },
});
// Real-time subscription function
var subscribeToWarehouseItems = function (dispatch, warehouseId) {
    var subscription = supabaseClient_1.supabase
        .channel("public:warehouseItems")
        .on("postgres_changes", {
        event: "*",
        schema: "public",
        table: "warehouseItems",
        filter: "warehouseId=eq.".concat(warehouseId),
    }, function (payload) {
        var _a;
        var newRecord = payload.new;
        var oldRecord = payload.old;
        switch (payload.eventType) {
            case "INSERT":
                dispatch((0, exports.addWarehouseItemRealTime)(newRecord));
                break;
            case "UPDATE":
                dispatch((0, exports.editWarehouseItemRealTime)(newRecord));
                break;
            case "DELETE":
                dispatch((0, exports.deleteWarehouseItemRealTime)((_a = oldRecord.id) !== null && _a !== void 0 ? _a : ""));
                break;
            default:
                break;
        }
    })
        .subscribe();
    return function () {
        subscription.unsubscribe();
    };
};
exports.subscribeToWarehouseItems = subscribeToWarehouseItems;
exports.default = warehouseItemsSlice.reducer;
